import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MaterialModule } from '@sharedModule/material/material.module';
import { ValueInputDialogData } from './value-input-dialog.model';

/**
 * Small reusable dialog that collects a single value (select / text / password /
 * number) and returns it on submit. Used for sender admin actions
 * (KYC/AML status, reset password, reset PIN).
 */
@Component({
  selector: 'app-value-input-dialog',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, MaterialModule],
  templateUrl: './value-input-dialog.component.html',
  styleUrl: './value-input-dialog.component.scss',
})
export class ValueInputDialogComponent {
  valueCtrl = new FormControl('', [Validators.required]);
  hide = true;

  /** Native input type, with the password toggle applied. */
  get inputType(): string {
    if (this.data.inputType === 'password') {
      return this.hide ? 'password' : 'text';
    }
    return this.data.inputType === 'number' ? 'number' : 'text';
  }

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ValueInputDialogData,
    private dialogRef: MatDialogRef<ValueInputDialogComponent>
  ) {}

  submit(): void {
    if (this.valueCtrl.valid) this.dialogRef.close(this.valueCtrl.value);
  }

  cancel(): void {
    this.dialogRef.close();
  }
}
